import React, { useRef } from "react";
import { ChevronLeft, ChevronRight, Video } from "lucide-react";
import { VIDEO_TESTIMONIALS } from "@/lib/site-data";
import VideoEmbed from "@/components/VideoEmbed";

export default function VideoTestimonials() {
  const scrollerRef = useRef(null);

  const scroll = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.85), behavior: "smooth" });
  };

  return (
    <section id="videos" className="py-20 md:py-28 bg-stone-900 text-white relative overflow-hidden" data-testid="testimonials-section">
      <div className="pointer-events-none absolute -top-40 -right-40 h-96 w-96 rounded-full bg-orange-600/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-orange-600/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange-600/15 border border-orange-600/30 text-orange-300 text-xs font-bold uppercase tracking-[0.2em]">
              <Video className="w-3.5 h-3.5" /> Em vídeo
            </div>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Histórias que ganham <span className="text-orange-400">voz e movimento.</span>
            </h2>
            <p className="mt-3 text-stone-300/80 max-w-2xl">
              Pacientes contam, em primeira pessoa, como a quiropraxia transformou sua rotina.
            </p>
          </div>
          <div className="flex gap-2">
            <button onClick={() => scroll(-1)} data-testid="testimonials-prev-btn" className="h-12 w-12 rounded-full bg-white/5 border border-white/15 hover:border-orange-500 hover:text-orange-400 transition-colors flex items-center justify-center">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={() => scroll(1)} data-testid="testimonials-next-btn" className="h-12 w-12 rounded-full bg-orange-600 hover:bg-orange-500 text-white transition-colors flex items-center justify-center">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div ref={scrollerRef} className="flex gap-5 overflow-x-auto snap-x snap-mandatory pb-6 no-scrollbar -mx-6 px-6">
          {VIDEO_TESTIMONIALS.map((v) => (
            <article key={v.id} data-testid={`video-card-${v.id}`} className="snap-start shrink-0 w-[260px] sm:w-[300px]">
              <VideoEmbed storageKey={`testimonial-${v.id}`} aspect="shorts" label={`Depoimento de ${v.name}`} />
              <div className="mt-3 px-1">
                <div className="font-semibold text-white text-sm">{v.name}</div>
                <div className="text-xs text-white/60">{v.when}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
